
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Store } from 'lucide-react';

interface BigCommerceIntegrationSettingsProps {
  initialConnected?: boolean;
  onSaved: () => Promise<void>;
}

const BigCommerceIntegrationSettings: React.FC<BigCommerceIntegrationSettingsProps> = ({ 
  initialConnected = false,
  onSaved 
}) => {
  const [isConnected, setIsConnected] = useState(initialConnected);
  const [storeUrl, setStoreUrl] = useState('');
  const [accessToken, setAccessToken] = useState('');
  const [clientId, setClientId] = useState('');

  const handleConnect = async () => {
    // Implement BigCommerce connection logic
    await onSaved();
    setIsConnected(true);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <Store className="mr-2 h-6 w-6" />
          BigCommerce Integration
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <Label>BigCommerce Connection</Label>
            <Switch 
              checked={isConnected}
              onCheckedChange={setIsConnected}
            />
          </div>

          {isConnected ? (
            <div className="space-y-4">
              <div>
                <Label>Store URL</Label>
                <Input 
                  value={storeUrl}
                  onChange={(e) => setStoreUrl(e.target.value)}
                  placeholder="https://store.bigcommerce.com"
                />
              </div>
              <div>
                <Label>Client ID</Label>
                <Input 
                  value={clientId}
                  onChange={(e) => setClientId(e.target.value)}
                  placeholder="Enter BigCommerce Client ID"
                />
              </div>
              <div>
                <Label>Access Token</Label>
                <Input 
                  type="password"
                  value={accessToken}
                  onChange={(e) => setAccessToken(e.target.value)}
                  placeholder="Enter BigCommerce Access Token"
                />
              </div>
              <Button onClick={handleConnect}>
                Update Connection
              </Button>
            </div>
          ) : (
            <Button onClick={handleConnect} className="w-full">
              Connect to BigCommerce
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default BigCommerceIntegrationSettings;
